<template>
  <com-header title="申请售后" bcColor="#f9f9f9">
    <div class="reback_goods">
      <div class="goods">
        <div class="img">
          <div class="box_img" v-for="(v,i) in imgList" :key="i">
            <img :src="v" alt="图片加载失败">
          </div>
        </div>
        <div class="itr">
          <div class="content">
            <span>{{orderGoodsMix.goodsMixNo}} </span>
            <span>{{orderGoodsMix.attr1ContentName || ""}} </span>
            <span>{{orderGoodsMix.attr2ContentName || ""}} </span>
            <span>{{orderGoodsMix.attr3ContentName || ""}} </span>
            <span>{{orderGoodsMix.attr4ContentName || ""}} </span>
            <span>{{orderGoodsMix.goodsCategoryName}}</span>
          </div>
          <div class="num">
            申请数量：
            <van-stepper v-model="query.applyCount" :integer="true" :max="999" />
          </div>
        </div>
      </div>

      <div class="reason">
        <div class="cell">
          <van-cell title="申请原因" required is-link :value="applyTypeText || '请选择申请原因'" @click="showReason = true" />
        </div>
        <div class="specific">
          <van-field v-model="query.applyReason" required rows="1" autosize type="textarea" clearable placeholder="请描述售后具体原因" />
        </div>
        <div class="upload_img">
          <van-uploader v-model="fileList" multiple upload-text="上传凭证(最多9张)" :max-count="9" :after-read="afterRead" />
        </div>
      </div>

      <div class="back_type">
        <div v-if="query.applyProType ===3">
          <van-cell required title="维修方式" is-link :value="repairText || '请选择维修方式'" @click="showRepairWay = true" />
        </div>
        <p class="tips" v-if="query.applyProType ===3">
          若因人为损坏，维修费用或运输费用自行承担！
        </p>
        <div v-if="query.applyProType ===1 || query.applyProType ===2 || query.repairWay === 2">
          <van-cell required title="退回方式" is-link :value="returnWayText || '请选择退回方式'" @click="showReturnWay = true" />
        </div>
        <p class="tips" v-if="query.applyProType ===1">
          若因个人原因退货，将在退款时扣除退货运费！
        </p>
        <div class="user" v-if="query.returnWay === 1 || query.repairWay === 1">
          <van-icon name="location" />
          <div class="content">
            <div>{{deliveryInfo.consignee}} {{deliveryInfo.consigneeTel}}</div>
            <div>
              {{deliveryInfo.deliveryProName || ""}}
              {{deliveryInfo.deliveryCityName || ""}}
              {{deliveryInfo.deliveryDisName || ""}}
              {{deliveryInfo.deliveryTownName || ""}}
              {{deliveryInfo.deliveryAddr || ""}}
            </div>
          </div>
        </div>
        <div v-if="query.returnWay === 1 || query.repairWay === 1">
          <van-cell :value="returnDateText+returnTimeText || '取件日期'" icon="notes-o" is-link @click="showReturnDate = true" />
        </div>
      </div>

      <div class="refund" v-if="query.applyProType === 1">
        <div class="cell">
          <van-cell title="退款方式" is-link value="原路退回" @click="showRefundWay = true" />
        </div>
      </div>

      <div class="addr" v-if="query.applyProType ===2 || query.applyProType ===4">
        <div class="cell">
          <van-cell center title="收货地址" value="与取件地址保持一致">
            <template #right-icon>
              <van-switch v-model="addrChecked" size="24" @change="onChangeChecked" />
            </template>
          </van-cell>
        </div>
      </div>

      <com-addr-list ref="refAddr"></com-addr-list>

      <div class="submit">
        <van-button type="danger" native-type="button" @click="onSubmit">确认并提交</van-button>
      </div>

      <!-- 申请原因 -->
      <van-action-sheet v-model="showReason" cancel-text="取消" description="请选择申请原因" :actions="reasonList" @select="onSelectReason" />
      <!-- 维修方式 -->
      <van-action-sheet v-model="showRepairWay" cancel-text="取消" description="请选择维修方式" :actions="repairWayList" @select="onSelectRepairWay" />
      <!-- 退回方式 -->
      <van-action-sheet v-model="showReturnWay" cancel-text="取消" description="请选择退回方式" :actions="returnWayList" @select="onSelectReturn" />
      <!-- 退回时间选择 -->
      <van-popup v-model="showReturnDate" position="bottom" class="date_time_pop" closeable round safe-area-inset-bottom>
        <div class="title">约时取</div>
        <div class="content">
          <ul class="date">
            <li :class="{active:query.returnDate==v.date}" v-for="(v,i) in returnDateList" :key="i" @click="onClickDate(v)">{{v.fullDate}}</li>
          </ul>
          <ul class="time">
            <li :class="{active:query.returnTime==v.date}" v-for="(v,i) in returnTimeList" :key="i" @click="onClickTime(v)">{{v.fullDate}}</li>
          </ul>
        </div>
      </van-popup>
      <!-- 退款方式 -->
      <van-popup v-model="showRefundWay" position="bottom" class="refund_pop" closeable round safe-area-inset-bottom>
        <div class="title">退款方式</div>
        <div class="content">
          <div class="item" @click="showRefundWay = false">
            <h1>￥</h1>
            <p>原路退回</p>
          </div>
        </div>
        <div class="itr">
          <p class="p1">退款说明</p>
          <p>在线支付支持原路返还；</p>
          <p>余额支付返回到余额；</p>
          <p>线下门店支付请联系门店。</p>
        </div>
      </van-popup>

      <!-- 小程序二维码 -->
      <van-dialog class="mydialog" v-model="showApplets" title="售后问题已成功提交，后续可通过小程序查询跟踪问题处理进度。" :show-confirm-button="false">
        <img :src="require('@/assets/img/qrCode2.png')" alt="">
        <div class="close" @click="onCloseApp">
          <van-icon name="close" />
        </div>
      </van-dialog>
    </div>
  </com-header>
</template>

<script>
import ComHeader from "./components/comHeader";
import ComAddrList from "./components/comAddrList";
import * as imageConversion from "image-conversion";
import {
  GetOrderAfterSaleGoodsMixInfo,
  GetReturnDateList,
  UploadTempImage,
  CreateAfterSaleOrder,
} from "@/pages/page1/api-work/index";
import {
  Button,
  Icon,
  Stepper,
  Field,
  cell,
  ActionSheet,
  Uploader,
  Popup,
  Switch,
  Dialog,
  Toast,
} from "vant";
export default {
  metaInfo: { title: "申请售后" },
  components: {
    ComHeader,
    ComAddrList,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Stepper.name]: Stepper,
    [Field.name]: Field,
    [cell.name]: cell,
    [ActionSheet.name]: ActionSheet,
    [Uploader.name]: Uploader,
    [Popup.name]: Popup,
    [Switch.name]: Switch,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      orderGoodsMix: {},
      deliveryInfo: {},
      imgList: [],
      showApplets: false,
      // 申请原因
      showReason: true,
      reasonList: [
        { name: "质量问题", value: 1 },
        { name: "发错货", value: 2 },
        { name: "其他", value: 3 },
      ],
      fileList: [],
      // 维修方式
      showRepairWay: false,
      repairWayList: [
        { name: "上门维修", value: 1 },
        { name: "返回维修", value: 2 },
      ],
      // 退回方式
      showReturnWay: false,
      returnWayList: [
        { name: "上门取件", value: 1 },
        { name: "自寄", value: 2 },
      ],
      // 取件日期
      showReturnDate: false,
      returnDateList: [],
      returnTimeList: [],
      // 退款方式
      showRefundWay: false,
      // 收货地址
      addrChecked: true,
      // 创建售后单 参数
      query: {
        orderGoodsMixId: undefined, //订单商品id
        applyProType: undefined, //申请处理方式（退货=1,换货=2,维修=3,补件=4）
        applyCount: 1, //申请数量

        applyType: undefined, //申请原因（质量问题=1,发错货=2,其他=3）
        applyReason: undefined, //申请事由（手动录入）

        repairWay: undefined, //维修时才存在维修方式（上门维修=1，返回维修=2）默认1
        returnWay: undefined, //维修为返回或者不是维修的情况才存在 退回方式（上门取件=1,自寄=2）默认1

        returnDate: undefined, //取件日期
        returnTime: undefined, //取件时间（09:00到15:00=1,15:00到21:00=2）

        refundWay: undefined, //退款方式（原路退回=1）

        serviceAddrId: undefined, //服务地址，订单地址
        reDeliveryAddrId: undefined, //新的收货地址
        proofList: [], //凭证图片列表
      },
    };
  },
  mounted() {
    Object.assign(this.query, this.$route.query);
    this.query.applyProType = parseInt(this.query.applyProType);
    this.getOrderGoodsMixInfo(this.query.orderGoodsMixId);
    this.getReturnDateList();
    // var vConsole = new VConsole();
    if (this.query.applyProType === 1) {
      this.query.refundWay = 1;
    }
    if (this.query.applyProType === 3) {
      this.query.repairWay = 1;
    } else {
      this.query.returnWay = 1;
    }
  },
  methods: {
    getOrderGoodsMixInfo(orderGoodsMixId) {
      GetOrderAfterSaleGoodsMixInfo({ orderGoodsMixId }).then((res) => {
        // console.log("商品信息", res);
        this.orderGoodsMix = res.data[0].orderGoodsMix;
        this.imgList.push(this.orderGoodsMix.mainPreviewImageFilePath || "");
        this.query.applyCount = this.orderGoodsMix.buyCount;

        this.deliveryInfo = res.data[0].deliveryInfo;
        this.query.serviceAddrId = this.deliveryInfo.deliveryAddrId; //默认服务地址
        if (this.query.applyProType === 2) {
          this.$store.commit("SET_ADDRID", this.deliveryInfo.deliveryAddrId); //默认收货地址
        }
      });
    },
    async afterRead(file) {
      // console.log("读取后", file);
      let localArr = file.length ? file : [file]; // 批量
      localArr.forEach((v) => {
        v.status = "uploading";
        v.message = "上传中...";
      });

      let fileArr = await this.compress(localArr); //本地压缩后图片
      let less300 = fileArr.filter((v) => v.file.size <= 300 * 1024); //小于300的上传服务器
      let more300 = fileArr.filter((v) => v.file.size > 300 * 1024); //大于300的本地展示
      console.log(
        "本次上传压缩后文件：",
        fileArr.map((v) => v.file.size),
        "小于307200：",
        less300.map((v) => v.file.size),
        "大于307200：",
        more300.map((v) => v.file.size)
      );
      const formData = new FormData();
      less300.forEach((v, i) => {
        formData.append("files" + i, v.file);
      });
      if (more300.length) {
        Toast.fail("超出文件大小限制（300.0 KB）");
        more300.forEach((v, i) => {
          v.status = "failed";
          v.message = "上传失败";
        });
      }
      // 上传到服务器
      UploadTempImage(formData)
        .then((res) => {
          // console.log("上传临时图片凭证结果", res);
          // 上传文件和结果数组一一对应
          less300.forEach((v, i) => {
            v.status = "done";
            v.message = "";
            v.url = res.data[i].savePath;
            v.size = res.data[i].tempSize;
          });
          console.log("本地总凭证", this.fileList);
        })
        .catch((err) => {
          less300.forEach((v) => {
            v.status = "failed";
            v.message = "上传失败";
          });
        });
    },
    // 图片压缩
    async compress(localArr) {
      let arr = localArr;
      for (let index = 0; index < arr.length; index++) {
        let v = arr[index];
        let res = await imageConversion.compressAccurately(v.file, {
          size: 280, //压缩为280KB
          accuracy: 0.95, //图像压缩大小的精度 默认0.95  误差280+14或者280-14
          width: 300, //分辨率要小 不然ios压不下去
          height: 300,
        });
        // console.log("压缩后blob", res);
        res = new File([res], v.file.name, {
          type: res.type,
          lastModified: Date.now(),
        });
        v.file = res;
        // console.log("压缩后file", res);
      }
      // console.log("倒数第二进行");
      return arr;
    },

    // 管理收货地址
    onChangeChecked(val) {
      // console.log(val);
      //选中 删除收货地址store 等于服务地址
      if (val) {
        this.$store.commit("SET_ADDRID", this.deliveryInfo.deliveryAddrId);
      }
      this.$refs.refAddr.openText(val);
    },

    // 申请原因
    onSelectReason(v) {
      this.showReason = false;
      this.query.applyType = v.value;
    },
    // 维修方式
    onSelectRepairWay(v) {
      this.showRepairWay = false;
      this.query.repairWay = v.value;
      if (v.value === 1) {
        this.query.returnWay = undefined;
      } else {
        this.query.returnWay = this.query.returnWay ? this.query.returnWay : 1;
        this.showReturnWay = true;
      }
    },
    // 退回方式
    onSelectReturn(v) {
      this.showReturnWay = false;
      this.query.returnWay = v.value;
    },
    // 取件日期
    getReturnDateList() {
      GetReturnDateList().then((res) => {
        // console.log(res);
        this.returnDateList = res.data;
        this.returnDateList.forEach((item) => {
          let arr = item.fullDate.split("-");
          let month = arr[1] + "月";
          let dateArr = arr[2].split("（");
          let date = dateArr[0] + "日（" + dateArr[1];
          item.fullDate = month + date;
        });

        this.returnTimeList = [];
        this.returnTimeList.push({
          date: 1,
          fullDate: "09:00—15:00",
        });
        this.returnTimeList.push({
          date: 2,
          fullDate: "15:00—21:00",
        });
        // 默认日期
        this.query.returnDate = this.returnDateList[0].date;
        this.query.returnTime = this.returnTimeList[0].date;
      });
    },
    onClickDate(v) {
      this.query.returnDate = v.date;
    },
    onClickTime(v) {
      this.query.returnTime = v.date;
      this.showReturnDate = false;
    },
    // 提交
    onSubmit() {
      // console.log(this.query);

      let errorImg = this.fileList.find((v) => v.status === "failed");
      if (errorImg) {
        Toast.fail("请保证图片上传正确");
        return;
      }

      //不默认地址的时候，又没有新的收货地址
      if (!this.addrChecked && !this.query.reDeliveryAddrId) {
        Toast.fail("请添加收货地址");
        return;
      }

      // 服务器图片处理
      this.query.proofList = [];
      let successFileList = this.fileList.filter((v) => v.status === "done");
      successFileList.forEach((v) => {
        this.query.proofList.push({
          proofFileSize: v.size,
          proofFileUrl: v.url,
        });
      });

      CreateAfterSaleOrder(this.query).then((res) => {
        // console.log("创建售后单", res);
        this.showApplets = true;
      });
    },
    onCloseApp() {
      this.$store.commit("SET_ADDRID", undefined);
      this.showApplets = false;
      this.$router.go(-2);
    },
  },
  computed: {
    addressID() {
      return this.$store.state.work.addressID;
    },
    applyTypeText() {
      let val = "";
      let res = this.reasonList.find((v) => v.value === this.query.applyType);
      if (res) {
        val = res.name;
      }
      return val;
    },
    repairText() {
      let val = "";
      let res = this.repairWayList.find(
        (v) => v.value === this.query.repairWay
      );
      if (res) {
        val = res.name;
      }
      return val;
    },
    returnWayText() {
      let val = "";
      let res = this.returnWayList.find(
        (v) => v.value === this.query.returnWay
      );
      if (res) {
        val = res.name;
      }
      return val;
    },
    returnDateText() {
      let val = "";
      let res = this.returnDateList.find(
        (v) => v.date === this.query.returnDate
      );
      if (res) {
        val = res.fullDate;
      }
      return val;
    },
    returnTimeText() {
      let val = "";
      let res = this.returnTimeList.find(
        (v) => v.date === this.query.returnTime
      );
      if (res) {
        val = res.fullDate;
      }
      return val;
    },
  },
  watch: {
    addressID(newV, oldV) {
      // console.log("监听变化", newV, oldV);
      this.query.reDeliveryAddrId = newV;
    },
    "query.applyType"(newV, oldV) {
      // console.log("监听变化1", newV, oldV);
      this.reasonList.forEach((v, i) => {
        v.color = "";
        if (newV === i + 1) v.color = "#ee0a24";
      });
    },
    "query.repairWay"(newV, oldV) {
      // console.log("监听变化2", newV, oldV);
      this.repairWayList.forEach((v, i) => {
        v.color = "";
        if (newV === i + 1) v.color = "#ee0a24";
      });
    },
    "query.returnWay"(newV, oldV) {
      // console.log("监听变化3", newV, oldV);
      this.returnWayList.forEach((v, i) => {
        v.color = "";
        if (newV === i + 1) v.color = "#ee0a24";
      });
      //自寄 控制服务地址 控制上门时间
      if (newV === 2) {
        this.query.serviceAddrId = undefined;

        this.query.returnDate = undefined;
        this.query.returnTime = undefined;
      } else {
        this.query.serviceAddrId = this.deliveryInfo.deliveryAddrId;

        if (this.returnDateList.length && this.returnTimeList.length) {
          this.query.returnDate = this.query.returnDate
            ? this.query.returnDate
            : this.returnDateList[0].date;
          this.query.returnTime = this.query.returnTime
            ? this.query.returnTime
            : this.returnTimeList[0].date;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.reback_goods {
  background-color: #f9f9f9;
  // min-height: calc(100vh - 0.8rem);
  min-height: 100vh;
  padding-bottom: 3rem;
  box-sizing: border-box;
  color: #878787;
  font-size: 14px;
  .goods {
    background: #ffffff;
    padding: 0.26rem 0.3rem;
    border-bottom: 1px solid rgb(241, 241, 241);
    display: flex;
    .img {
      margin-top: 0.04rem;
      width: 1.4rem;
      height: 1.4rem;
      border: 1px solid rgba(168, 168, 168, 0.4);
      box-sizing: border-box;
      .box_img {
        width: 100%;
        height: 100%;
      }
    }
    .itr {
      width: calc(100% - 1.4rem);
      padding-left: 0.4rem;
      box-sizing: border-box;
      font-size: 12px;
      color: #333333;
      line-height: 14px;
      padding-top: 0.1rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .num {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: @themeColor;
      }
    }
  }
  .reason {
    margin-top: 0.4rem;
    background: #ffffff;
    padding: 0 0.3rem;
    .cell {
      .van-cell {
        padding: 0.2rem 0;
      }
    }
    .specific {
      margin-top: 0.2rem;
      .van-cell {
        background: #f2f2f2;
        border-radius: 6px;
      }
    }
    .upload_img {
      padding: 0.4rem 0;
      position: relative;
      &::after {
        position: absolute;
        top: 0.5rem;
        left: -8px;
        color: #ee0a24;
        font-size: 14px;
        content: "*";
      }
      /deep/ .van-uploader {
        .van-uploader__wrapper {
          .van-uploader__upload {
            .van-uploader__upload-text {
              padding: 0 0.2rem;
              line-height: 16px;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .back_type {
    margin-top: 0.4rem;
    background: #ffffff;
    padding: 0 0.3rem;
    .van-cell {
      padding: 0.2rem 0;
    }
    .tips {
      padding: 0.1rem;
      font-size: 12px;
      background: #fef0de;
      position: relative;
      left: 0;
      top: -0.2rem;
    }
    .user {
      padding: 0.2rem 0;
      border-top: 1px solid #ebedf0;
      display: flex;
      line-height: 18px;
      i {
        color: #8b8b8b;
        font-size: 18px;
        padding-top: 0.1rem;
        width: 0.6rem;
      }
    }
  }
  .refund {
    margin-top: 0.4rem;
    background: #ffffff;
    padding: 0 0.3rem;
    .cell {
      .van-cell {
        padding: 0.2rem 0;
      }
    }
  }
  .addr {
    margin-top: 0.4rem;
    background: #ffffff;
    padding: 0 0.3rem;
    border-bottom: 1px solid #ebedf0;
    .cell {
      .van-cell {
        padding: 0.2rem 0;
      }
    }
  }
  .submit {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 2;
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    padding: 0 16px;
    padding-bottom: constant(safe-area-inset-bottom); //适配ios的底部 先constant
    padding-bottom: env(safe-area-inset-bottom); //再env
    background-color: #f9f9f9;
    .van-button {
      width: 100%;
      height: 40px;
      margin: 5px 0;
      border-radius: 999px;
    }
  }

  .date_time_pop {
    padding: 0.3rem;
    box-sizing: border-box;
    .title {
      text-align: center;
      color: #333333;
      padding-bottom: 0.3rem;
    }
    .content {
      display: flex;
      .date {
        background: #f2f2f2;
        width: 3.6rem;
        font-size: 14px;
        li {
          width: 100%;
          height: 0.8rem;
          text-align: center;
          line-height: 0.8rem;
        }
        .active {
          background: #fef0de;
        }
      }
      .time {
        width: calc(100% - 3.6rem);
        display: flex;
        flex-direction: column;
        align-items: center;
        li {
          margin-top: 0.6rem;
          width: 2.4rem;
          height: 1.2rem;
          box-sizing: border-box;
          text-align: center;
          line-height: 1.2rem;
          background: #f2f2f2;
          border: 1px solid #d7d7d7;
        }
        .active {
          background: #fef0de;
          border-color: @themeColor;
        }
      }
    }
  }
  .refund_pop {
    padding: 0.3rem;
    box-sizing: border-box;
    .title {
      text-align: center;
      color: #333333;
      padding-bottom: 0.3rem;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 1.4rem;
        height: 1.4rem;
        margin-left: 0.3rem;
        box-sizing: border-box;
        border-radius: 5px;
        background: #fef0de;
        border: 1px solid @themeColor;
        color: @themeColor;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h1 {
          padding-bottom: 0.1rem;
          font-size: 24px;
        }
      }
    }

    .itr {
      margin-top: 0.4rem;
      line-height: 24px;
      .p1 {
        padding-bottom: 0.2rem;
        color: #333333;
      }
    }
  }

  /deep/ .mydialog {
    .van-dialog__header {
      padding: 26px 30px 0;
    }
    .van-dialog__content {
      display: flex;
      justify-content: center;
      padding: 0.6rem 0;
      .close {
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
      }
      img {
        width: 4rem;
        height: 4rem;
      }
    }
  }
  .van-cell--required::before {
    left: -8px;
  }
}
</style>